/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-3d-drawing.scss';

import { Context3D } from './silo-3d-drawing';

/* eslint-disable import/no-unresolved, import/default */

import silo3dDrawingTemplate from './silo-3d-drawing.tpl.html';
//import tinycolor from "tinycolor2";

/* eslint-enable import/no-unresolved, import/default */


export default angular.module('agrolog.common.silo.3dDrawing', [])
    .directive('agSilo3dDrawing', Silo3dDrawing)
    .name;

/*@ngInject*/
function Silo3dDrawing() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            siloData: '=',
            telemetryType: '<',
            mode: '='
        },
        controller: Silo3dDrawingController,
        controllerAs: 'vm',
        templateUrl: silo3dDrawingTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function Silo3dDrawingController($scope, $element, $log, agTypes) {
    
    let vm = this;

    vm.agTypes = agTypes;

    if (vm.telemetryType === agTypes.telemetry.type.temperature) {
        vm.telemetryColors = agTypes.colors.tempMatrixColors;
    } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
        vm.telemetryColors = agTypes.colors.moistureMatrixColors;
    } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
        vm.telemetryColors = agTypes.colors.co2MatrixColors;
    }

    vm.telemetryLimits = [];
    const tempLimitInterval = 4;
    computeTemperatureLimits(25);

    vm.drawingElement = angular.element('#sceneCanvas', $element);

    let options = {...agTypes.drawing3d, ...{
        logger: $log, showCompass: true
    }}
    vm.context = new Context3D(vm.drawingElement[0], options);
    vm.siloGeometry = {};
    vm.sensorLinesGeometry = [];
    vm.cropGeometry = {};
    vm.disabledSensors = {};

    vm.silo_object = null;

    $scope.$watch('vm.siloData', () => {
        if (vm.siloData) {
            updateGeometry();
        } else {
            clear();
        }
    }, true);

    $scope.$on("$destroy", function () {
        clear();
        vm.context.dispose();
    });

    $scope.$on('onSiloSensorData', function($event, sensorsData) {
        updateSensorColors(sensorsData)
    });

    $scope.$on('onSiloSensorSelected', function($event, lineNum, sensorIndex) {
        vm.silo_object.hightlightSensor(lineNum, sensorIndex)
    });

    function clear(){
        vm.context.clear()
        vm.disabledSensors = {};
        vm.cropGeometry = null
        vm.silo_object = null;
    }

    function updateGeometry() {
        let silo = vm.siloData.silo;
        vm.siloType = silo.siloType;

        vm.disabledSensors = computeDisabledSensors(vm.siloData);

        if (vm.telemetryType === agTypes.telemetry.type.temperature) {
            computeTemperatureLimits(silo.maxTemperature);
        } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
            computeTemperatureLimits(silo.maxMoisture);
        } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
            computeTemperatureLimits(silo.maxCO2);
        }

        if (vm.siloData.cropData) {
            vm.cropGeometry = angular.copy(vm.siloData.cropData);
        }

        redraw();
    }

    function computeDisabledSensors(siloData) {
        let enabledSensorsAttr = siloData.silo.enabledSensors;
        let disabledSensors = {};
        if (enabledSensorsAttr) {
            let enabledSensors = angular.fromJson(enabledSensorsAttr);
            siloData.sensorLines.forEach((sensorLine) => {
                let sensorLineDisabledSensors = [];
                let sensorLineEnabledSensors;
                if (enabledSensors[sensorLine.id.id]) {
                    sensorLineEnabledSensors = enabledSensors[sensorLine.id.id];
                } else {
                    sensorLineEnabledSensors = [];
                }
                for (let sensorId=0;sensorId<sensorLine.sensorCount;sensorId++) {
                    if (sensorLineEnabledSensors.indexOf(sensorId) === -1) {
                        sensorLineDisabledSensors.push(sensorId);
                    }
                }
                disabledSensors[sensorLine.lineNum] = sensorLineDisabledSensors;
            });
        } else {
            siloData.sensorLines.forEach((sensorLine) => {
                disabledSensors[sensorLine.lineNum] = [];
            });
        }
        return disabledSensors;
    }

    function computeTemperatureLimits(maxTemperature){
        if (angular.isUndefined(maxTemperature) || maxTemperature == null){
            maxTemperature = 25;
        }
        vm.telemetryLimits = [];
        let tempLimitStep = maxTemperature / tempLimitInterval;
        for (let t=0;t<=maxTemperature;t+=tempLimitStep) {
            vm.telemetryLimits.push(t);
        }
    }

    function redraw() {
        vm.context.clear()
        let silo = vm.siloData.silo;
        
        // NOTE: caller should properly supply the LIN-device instead of crop-geometry
        let hasCrop = vm.cropGeometry && Object.keys(vm.cropGeometry).length > 0
        
        let options = {
            label: silo.name,
            telemetryType: vm.telemetryType,
            telemetryLimits: vm.telemetryLimits,
            hasAlarm: false, 
            showCables: !hasCrop, showCrop: hasCrop
        }

        let devices = []

        
        if (!hasCrop) {
            devices = vm.siloData.sensorLines.map(sline => {
                return {
                    id: sline.id.id, type: sline.type, attributes: sline
                }
            })
        } else {
            devices = vm.siloData.levelIndicators || []
        }

        let assetData = {
            id: silo.id.id, 
            type: silo.type,
            attributes: silo,
            devices: devices,
            options: options
        }
        
        //$log.info('redraw', assetData)
        vm.silo_object = vm.context.addAsset(assetData);
        vm.context.setId('detail-' + silo.id.id)
        vm.context.lookAtAsset(silo.id.id)
        vm.context.redraw();

        if (hasCrop) {
            vm.silo_object.updateCrop(vm.cropGeometry);
        } else {
            vm.silo_object.setDisabledSensors(vm.disabledSensors);
        }

        
    }

    function updateSensorColors(data){
        if (vm.silo_object !== null){
            vm.silo_object.updateSensorValues(data)
        }
    }
}